var map = {
	"./aprovavp/white-logo.svg": 43894,
	"./backupDemo/white-logo.svg": 30330,
	"./brasilstartups/white-logo.svg": 45312,
	"./canaleducacao/white-logo.svg": 34607,
	"./egepi/white-logo.svg": 53429,
	"./fic/white-logo.svg": 42839,
	"./iesb/white-logo.svg": 21704,
	"./inkluziva/white-logo.svg": 34106,
	"./kubi/white-logo.svg": 26306,
	"./maiseducacao/white-logo.svg": 56516,
	"./oab/white-logo.svg": 40203,
	"./oros/white-logo.svg": 62688,
	"./powerforgirls/white-logo.svg": 67926,
	"./quartosecretariado/white-logo.svg": 54179,
	"./retina/white-logo.svg": 57768,
	"./seducpi/white-logo.svg": 85934,
	"./sett-solutions/white-logo.svg": 87418,
	"./siape/white-logo.svg": 54217,
	"./tjpara/white-logo.svg": 23131,
	"./unisescoop/white-logo.svg": 55158,
	"./vegalabs/white-logo.svg": 38674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61125;